<mat-checkbox class="mat-option" [indeterminate]="isIndeterminate()" [checked]="isChecked()" color="primary"
    (change)="toggleSelection($event)">
    {{ 'check_all' | translate}}
</mat-checkbox>
